import { MarkovState } from "server/models"
import { OrderType } from "client/utils"

export interface MarkovStateProps {
    stateId: number
}

export type MarkovStateValidation = { [key in keyof MarkovState]?: string}

export interface MarkovStateList { [stateId: number]: MarkovState }
export interface MarkovStateFilters {
    search?: string
}

export interface MarkovStateState {
    stateList: MarkovStateList
    stateIds: readonly number[]
    stateEdit: MarkovState

    sortColumn: keyof MarkovState
    sortOrder: OrderType
    filters: MarkovStateFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_STATE_LIST = "MARKOV_STATE_LIST"
export const MARKOV_STATE_IDS = "MARKOV_STATE_IDS"
export const MARKOV_STATE_EDIT = "MARKOV_STATE_EDIT"

export const MARKOV_STATE_SORT = "MARKOV_STATE_SORT"
export const MARKOV_STATE_FILTERS = "MARKOV_STATE_FILTERS"

export const MARKOV_STATE_RELOAD_LIST = "MARKOV_STATE_RELOAD_LIST"
export const MARKOV_STATE_RELOAD_EDIT = "MARKOV_STATE_RELOAD_EDIT"
